<div class="loader">
  <div class="dimmed" [hidden]="status != STATUS_LOADING">
    <div class="dimmed_title"></div>
    <div class="dimmed_subtitle"></div>
  </div> 
<!--  <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading> -->
</div> 
<!-- ATTACHMENTS (project-details-attachments: duplicated class with faterh comp)-->
<div *ngIf="status == STATUS_DONE" class="project-details-attachments">
  <header>
    <h3>ATTACHMENTS</h3>
    <h4 *ngIf="attachments == null"><div class="loader loader_small"><core-helpers-box-loading></core-helpers-box-loading></div> <span>Attachments</span></h4>
    <h4 *ngIf="show && attachments != null" (click)="toggleAttachments()"><em>{{attachments.length}}</em> <span class="arrow-up">Attachment{{(attachments.length > 1 || attachments.length == 0) ? 's':''}}</span></h4>
    <h4 *ngIf="!show && attachments != null" (click)="toggleAttachments()"><em>{{attachments.length}}</em> <span class="arrow-down">Attachment{{(attachments.length > 1 || attachments.length == 0) ? 's':''}}</span></h4>
    <div class="header-tools" [hidden]="!show">
      <div class="header-button">

      </div>
    </div>
  </header>
    <!-- upload box -->
  <project-details-info-attachments-upload
    [hidden]="!showUpload"
    (done)="onUploadDone($event)"
  ></project-details-info-attachments-upload>
  <article [hidden]="!show">


    <!-- maybe articles && maybe modify component to show actives/inactives in list with an option-->
    <project-details-info-attachments-list
      [project]="project"
      [files]="attachments"
      [notes]="notes"
      (actionClick)="onClickPreview($event)"
    ></project-details-info-attachments-list>

    <!-- End ATTACHMENTS -->
  </article>
</div >
